import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-table-9x",
  "use": "icon-table-9x-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-9x\">\n<rect width=\"20\" height=\"20\" fill=\"white\" fill-opacity=\"0.01\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 4H8V7H5V4ZM5 12H8V15H5V12ZM9 12H12V15H9V12ZM16 12H13V15H16V12ZM12 4H9V7H12V4ZM13 4H16V7H13V4ZM8 8H5V11H8V8ZM9 8H12V11H9V8ZM16 8H13V11H16V8Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol